/**
 * Represents types of audit events for administrative records.
 */
export enum AdminRecordsAuditEventTypeModel {
	UpdateCustomer = 1,
	CreateCustomer = 2,
	UpdateLocation = 3,
	CreateLocation = 4,
	DeleteLocation = 5,
	UpdateCustomerNdcDestination = 6,
	CreateCustomerNdcDestination = 7,
	DeleteCustomerNdcDestination = 8,
	UpdateNdcDestination = 9,
	CreateNdcDestination = 10,
	DeleteNdcDestination = 11,
	CreateNdcDestinationsFromImportFile = 12,
	UpdateNdcDestinationsFromImportFile = 13
}
